import React, { Component } from 'react';
import Sidebar from '../Sidebar';
import moment from 'moment-with-locales-es6';
import { connect} from "remx";
import broker from '../../../utils/broker';
import config from '../../../utils/config';

import dataStore from '../../../stores/data';

import ListFiles from './ListFiles';
import SidebarTree from '../SidebarTree';


class Laporan extends Component {
    constructor(props) {
        super(props);
    
    this.options = {

    }

    this.state = {
            reload:false,
            loading: false,
            id_pk_column: 'id',
            detail_kategori : {},
            data_pelanggan : [],
            drag_marker : false,
            show_graphic : false,
            download : false,
            url_report: '',
        }
    }

    prevNextDay(count){
        var type_view = this.props.type_view;
        var date = this.props.date_view;
        if (type_view === 'month'){
            date = moment(date).add(count, 'month');
        } else {
            date = moment(date).add(count, 'days');
        }
        dataStore.setters.setDataDateView(moment(date).locale('id').format('YYYY-MM-DD'));
        dataStore.setters.setDataMonthView(parseInt(moment(date).locale('id').format('MM'))-1);
        this.setState({prev_next : (count === (+1)) ? 'next' : 'prev'});
    }

    setDataType(type) {
        // dataStore.setters.setDataMonthView(parseInt(moment().locale('id').format('MM'))-1);
    
        dataStore.setters.setDataTypeView(type);
    }

    setNow(){
        dataStore.setters.setDataDateView(moment().locale('id').format('YYYY-MM-DD'));
        dataStore.setters.setDataTypeView('day');
        dataStore.setters.setDataMonthView(parseInt(moment().locale('id').format('MM'))-1);
        this.setState({prev_next : ''});
    }
    
    componentDidMount(){
        var addScript = document.createElement('script');
        addScript.setAttribute('src', '/assets/js/dashforge.filemgr.js');
        document.body.appendChild(addScript);

        if (this.props.data_kategori_per.id_kategori) {
            this.getDataKategoriPer();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.data_kategori_per !== prevProps.data_kategori_per){
            this.getDataKategoriPer();
        }

        if (this.props.type_view !== prevProps.type_view ||
            this.props.month_view !== prevProps.month_view ||
            this.props.date_view !== prevProps.date_view ||
            this.props.pelanggan_id !== prevProps.pelanggan_id) {
              
            this.setState({show_graphic: false, download: false});
        }

    }


    getDataKategoriPer(){
        broker.fetch.get(`data/kategori/${this.props.data_kategori_per.id_kategori}`)
        .then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({detail_kategori : data})
            } else {

            }
        }).catch(err => {
            
        });
    }


    generateContent(){
        var content = this.state.detail_kategori;
        // console.log(content)
        let return_content = [];
        if (content) {
            for (var key in content){
                if(!key.includes('id') && !key.includes('created_at') && !key.includes('updated_at'))
                    return_content.push(<React.Fragment key={key}>
                                            <label className="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase" key={key}>{key.replace("_", " ")}</label>
                                            <p className="tx-13 mg-b-10">{content[key]}</p>
                                        </React.Fragment>);
    
            }
        }

        return return_content;
    }

    render(){
        return(
            <div className="contact-wrapper">
                <SidebarTree />
                <div className="filemgr-content">
                    <div className="chat-content-header" style={{marginTop: '-5px'}}>
                       <div>
                        <h6 id="channelTitle" className="mg-b-0">#DownloadLaporan</h6>
                       </div>
                    </div>
                    <div className="filemgr-content-body" style={{marginRight: '288px'}}>
                        <ListFiles />
                    </div>
                    <div className="contact-content-sidebar">
                        <label className="nav-label tx-color-03">Detail Data</label>
                        <hr className="mg-t-0"></hr>
                        {(this.state.detail_kategori) &&
                            this.generateContent()
                        }
                       
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps(props) {
    return {
        pelanggan_id : dataStore.getters.getDataPelangganId(),
        type_view : dataStore.getters.getDataTypeView(),
        year_view : dataStore.getters.getDataYearView(),
        month_view : dataStore.getters.getDataMonthView(),
        date_view : dataStore.getters.getDataDateView(),
        form_view : dataStore.getters.getDataFormView(),
        lat_lng : dataStore.getters.getLatLon(),
        data_pelanggan : dataStore.getters.getDataPelanggan(),
        data_kategori : dataStore.getters.getDataKategori(),
        data_kategori_per : dataStore.getters.getDataKategoriPer(),
    }
}


export default connect(mapStateToProps)(Laporan);